import { Card, Col, Container, Row } from 'react-bootstrap';
import BranchForm from './BranchForm';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import paths from 'routes/paths';
import useUpload from 'hooks/useUpload';
import { useBranch, useUpdateBranch } from 'hooks/useBranches';

// -------------------------------------
export default function EditBranch() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Use Supabase hooks
  const { branch, isLoading } = useBranch(id);
  const { updateBranchAsync, isUpdating } = useUpdateBranch();
  const { upload, deleteFile, loading: uploadLoading } = useUpload();

  const onSubmit = async values => {
    const image = values.logo;
    try {
      // Upload image if it's a new file
      if (image && typeof image !== 'string') {
        // Delete old logo first if it exists
        if (branch?.logo && branch.logo.includes('supabase')) {
          try {
            await deleteFile(branch.logo);
            console.log('Old logo deleted successfully');
          } catch (error) {
            console.error('Failed to delete old logo:', error);
            // Continue anyway - not critical if delete fails
          }
        }

        // Upload new logo
        const profileUrl = await upload(image, 'branches');
        values.logo = profileUrl;
      }

      // Update branch in Supabase
      await updateBranchAsync({
        id: values.id,
        data: {
          name: values.name,
          address: values.address || '',
          city: values.city,
          currency_id: values.currency_id,
          location_id: values.location_id,
          logo: values.logo,
          organisation_id: values.organisation_id,
          phone: values.phoneNumber || values.phone || ''
        }
      });

      // Navigate back to branches list on success
      navigate(paths.branchesSetting);
    } catch (e) {
      console.error('Update branch error:', e);
      toast.error('Something went wrong! Please try again later!');
    }
  };
  return (
    <Container fluid className="px-0">
      <Row>
        <Col sm={12} md={7}>
          <Card>
            <Card.Body>
              <BranchForm
                loading={isLoading || isUpdating || uploadLoading}
                onSubmit={onSubmit}
                isEdit
                initValues={branch || {}}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
